import React from 'react';
import { CloseButton, Iframe, Wrapper } from './InAppBar.styled';

const InAppBar = ({ onClose, url, language }) => (
	<Wrapper>
		<Iframe allow="fullscreen" src={url.replace('{lang}', language)} />
		<CloseButton variant="icon" startIcon="close-16" size="sm" onClick={onClose} />
	</Wrapper>
);

export default InAppBar;
